import { ICompany } from './company.interface';
import axios from 'axios';
import { BaseService } from '@/features/base/api/base.api';

class CompanyService extends BaseService {
  private static instance: CompanyService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public all(): Promise<IApi<ICompany[]>> {
    return this.get<ICompany[]>(`${this.baseUrl}/api/companies`);
  }

  public add(company: ICompany): Promise<IApi<ICompany>> {
    return this.postItem<ICompany>(`${this.baseUrl}/api/companies`, company);
  }

  public update(company: ICompany): Promise<IApi<ICompany>> {
    return this.putItem<ICompany>(`${this.baseUrl}/api/companies/${company.id}`, company);
  }

  public delete(id: string): Promise<IApi<string>> {
    return this.deleteItem<string>(`${this.baseUrl}/api/companies/${id}`);
  }

  public download(id: string): Promise<any> {
    return this.downloadItem(`${this.baseUrl}/api/companies/download/${id}`);
  }
}

export const companyService = CompanyService.Instance;
